import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Testimonials.css';

const testimonials = [
  {
    text: 'Paradise Events e beri dasmen tone absolutisht magjike. Cdo detaj ishte perfekte, nga dekorimi deri te muzika. Nuk mund te ishim me te lumtur!',
    name: 'Ariana & Driton',
    role: 'Dasma, Pristine 2024',
    rating: 5,
  },
  {
    text: 'Profesionalizmi dhe kreativiteti i ekipit te Paradise Events eshte i jashtezakonshem. Ata e kuptuan vizionin tone dhe e realizuan edhe me mire se sa prisnim.',
    name: 'Blerina K.',
    role: 'Event Korporativ, 2024',
    rating: 5,
  },
  {
    text: 'Fishekzjarret dhe efektet speciale ishin spektakolare! Te gjithe mysafiret ishin te mahnitur. Faleminderit Paradise Events per nje nate te paharrueshme.',
    name: 'Ermal & Fjolla',
    role: 'Dasma, Prizren 2023',
    rating: 5,
  },
  {
    text: 'Ekipi me i mire i eventeve ne Kosove. Punonin me pasion, me kujdes per cdo detaj. E rekomandojme me zemer te plote per cdo event.',
    name: 'Valon M.',
    role: 'Festa e 50-vjetorit, 2024',
    rating: 5,
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: true });

  const next = useCallback(() => {
    setDirection(1);
    setCurrent((prev) => (prev + 1) % testimonials.length);
  }, []);

  const prev = () => {
    setDirection(-1);
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [next]);

  const variants = {
    enter: (dir) => ({ x: dir > 0 ? 80 : -80, opacity: 0 }),
    center: { x: 0, opacity: 1 },
    exit: (dir) => ({ x: dir > 0 ? -80 : 80, opacity: 0 }),
  };

  return (
    <section className="testimonials section-padding" id="testimonials" ref={ref}>
      {/* Background quote */}
      <div className="testimonials__bg-quote">&ldquo;</div>

      <div className="section-container">
        <motion.div
          className="testimonials__header"
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">Deshmite</span>
          <h2 className="section-title">
            Cfare thone <em>klientet</em> tane
          </h2>
        </motion.div>

        <div className="testimonials__carousel">
          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              key={current}
              className="testimonials__slide"
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            >
              {/* Stars */}
              <div className="testimonials__stars">
                {Array.from({ length: testimonials[current].rating }).map((_, i) => (
                  <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="var(--gold)">
                    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
                  </svg>
                ))}
              </div>

              <blockquote className="testimonials__text">
                &ldquo;{testimonials[current].text}&rdquo;
              </blockquote>

              <div className="testimonials__author">
                <div className="testimonials__author-avatar">
                  {testimonials[current].name.charAt(0)}
                </div>
                <div>
                  <h4 className="testimonials__author-name">
                    {testimonials[current].name}
                  </h4>
                  <p className="testimonials__author-role">
                    {testimonials[current].role}
                  </p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Controls */}
          <div className="testimonials__controls">
            <button className="testimonials__arrow" onClick={prev} aria-label="Previous">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
            </button>

            <div className="testimonials__dots">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  className={`testimonials__dot ${i === current ? 'testimonials__dot--active' : ''}`}
                  onClick={() => { setDirection(i > current ? 1 : -1); setCurrent(i); }}
                  aria-label={`Slide ${i + 1}`}
                />
              ))}
            </div>

            <button className="testimonials__arrow" onClick={next} aria-label="Next">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
